import React, { Fragment } from 'react'
import {
    List,
    Datagrid,
    NumberField,
    TextField,
    ReferenceField,
} from 'react-admin'

import Title from '../Generic/Title'

export const ComunaList = ({ permissions, ...props }) => {
    if (permissions === null) return null
    return (
        <Fragment>
            <Title title={"Comunas"} />
            <List {...props} sort={{ field: 'id', order: 'ASC' }} exporter={false} >
                <Datagrid rowClick="edit">
                    <NumberField source="id" />
                    <NumberField source="code" label="Código" />
                    <TextField source="name" label="Nombre"/>
                    <ReferenceField source="region" reference="regiones">
                        <TextField source="name" />
                    </ReferenceField>
                    <ReferenceField source="provincia" reference="provincias">
                        <TextField source="name" />
                    </ReferenceField>
                </Datagrid>
            </List>
        </Fragment>
    )
}
